import React from 'react';

import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
import OptionsListItem from '@/modules/corporate/modules/questions/fields/components/Editor/OptionsListItem';
import { EditorOptionsListItemProps } from '@/modules/corporate/modules/questions/fields/components/Editor/OptionsListItem/types';

const CLASSES = { root: 'px-10', optionItem: 'ms-12' };

const EditorOptionsListItem = (props: EditorOptionsListItemProps) => {
  const { className } = props;

  return (
    <Stack className={cn('group mb-10', className)} gapX={8}>
      <OptionsListItem {...props} classes={CLASSES} isDeletable={false} isEditable={false} />
    </Stack>
  );
};

export default EditorOptionsListItem;
